define('MiniCartModal',[
    "jquery",
    "eventManager",
    "SageDotCom/DataLayer/tealium"
], function ($, eventManager, tealium) {

    function MiniCartModal() {

        eventManager.subscribe("Sage:OpenModal", triggerOpenModalEvent);
        eventManager.subscribe("Sage:CloseModal", triggerCloseModalEvent);
    }

        function getEventData(data, element, isOpen) {
            var eventData = {
                "event_name": isOpen ? "modal_open" : "modal_close",
                "event_non-int": "0",
                "event_category": "component",
                "event_action": isOpen ? "modal_open" : "modal_close",
                "event_label": $(element)[0].innerText,
                "event_name_level_1": $(element)[0].id,
                "event_name_level_2": data.productSku,
                "event_name_level_3": data.productLabel,
                "event_name_level_4": $(element)[0].parentElement.className         
            };

            return eventData;
    }

    function triggerOpenModalEvent(data,element) {
        var eventData = getEventData(data,element, true);
        tealium.event(eventData);
    }

    function triggerCloseModalEvent(data, element) {
        var eventData = getEventData(data,element, false);
        tealium.event(eventData);
    }

        return new MiniCartModal();
});
